(() => {
  const tabConfigs = [
    {
      type: 'specs',
      sectionSelector: '[id^="shopify-section"][id*="product-tabs-with-specs"]',
      wrapperSelector: '[id^="ProductSpecs--"]',
      navItemClass: '.tabs-with-specs__nav-item',
      navListSelector: '.tabs-with-specs__nav ul',
      tabClass: '.tab-block',
    },
    {
      type: 'faq',
      sectionSelector: '[id^="shopify-section"][id*="tabs-with-faq"]',
      wrapperSelector: '[id^="TabsWithFAQ--"]',
      navItemClass: '.tabs-with-faq__nav-item',
      navListSelector: '.tabs-with-faq__nav ul',
      tabClass: '.tab-block',
    },
    {
      type: 'table',
      sectionSelector: '[id^="shopify-section"][id*="tabs-with-table"]',
      wrapperSelector: '[id^="TabsWithTable--"]',
      navItemClass: '.tabs-with-table__nav-item',
      navListSelector: '.tabs-with-table__nav ul',
      tabClass: '.tab-block',
    },
    {
      type: 'columns',
      sectionSelector: '[id^="shopify-section"][id*="tabs-with-columns"]',
      wrapperSelector: '[id^="TabsWithColumns--"]',
      navItemClass: '.tabs-with-columns__nav-item',
      navListSelector: '.tabs-with-columns__nav ul',
      tabClass: '.tab-block',
    },
    {
      type: 'videos',
      sectionSelector: '[id^="shopify-section"][id*="tabs-with-videos"]',
      wrapperSelector: '[id^="TabsWithVideos--"]',
      navItemClass: '.tabs-with-videos__nav-item',
      navListSelector: '.tabs-with-videos__nav ul',
      tabClass: '.tab-block',
      initExtra: initTabSliders,
    },
  ];

  const activeTabs = new Map();

  function activateTab(tabs, navItems, sectionId, targetId, focusNav = false, extra = null) {
    tabs.forEach((tab) => {
      const isActive = tab.id === targetId;
      tab.classList.toggle('active', isActive);
      tab.setAttribute('role', 'tabpanel');
      const tabButtonId = `tab-button-${tab.id}`;
      const heading = tab.querySelector('[data-tab-title]');
      /* Only reference elements that exist — a dangling aria-labelledby is an
         ARIA violation (broken reference). */
      const labelId = document.getElementById(tabButtonId) ? tabButtonId : heading?.id || null;
      if (labelId) {
        tab.setAttribute('aria-labelledby', labelId);
      } else {
        tab.removeAttribute('aria-labelledby');
      }
      if (isActive) {
        tab.removeAttribute('hidden');
        tab.removeAttribute('aria-hidden');
        tab.setAttribute('tabindex', '0');
        if (typeof extra === 'function') extra(tab);
      } else {
        tab.setAttribute('hidden', '');
        tab.setAttribute('aria-hidden', 'true');
        tab.setAttribute('tabindex', '-1');
      }
    });


    let activeNav = null;
    navItems.forEach((item) => {
      const isActive = item.dataset.tab === targetId;
      item.classList.toggle('active', isActive);
      item.setAttribute('aria-selected', isActive ? 'true' : 'false');
      item.setAttribute('tabindex', isActive ? '0' : '-1');
      if (isActive) activeNav = item;
    });

    activeTabs.set(sectionId, targetId);
    if (focusNav && activeNav) activeNav.focus();
  }

  function tabTitle(tab) {
    return tab.querySelector('[data-tab-title]')?.textContent?.trim() || '';
  }

  function namedTabs(tabs) {
    return tabs.filter((tab) => Boolean(tabTitle(tab)));
  }

  function buildNav(navList, tabs, className) {
    navList.innerHTML = '';
    namedTabs(tabs).forEach((tab) => {
      const li = document.createElement('li');
      li.className = className.replace('.', '');
      li.setAttribute('role', 'presentation');

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = `${className.replace('.', '')}__button`;
      btn.dataset.tab = tab.id;

      btn.id = `tab-button-${tab.id}`;
      btn.textContent = tabTitle(tab);

      btn.setAttribute('role', 'tab');
      btn.setAttribute('aria-controls', tab.id);
      btn.setAttribute('aria-selected', 'false');
      btn.setAttribute('tabindex', '-1');

      li.appendChild(btn);
      navList.appendChild(li);
    });
  }

  function syncNavLabels(navList, tabs) {
    const buttons = Array.from(navList.querySelectorAll('[role="tab"]'));
    namedTabs(tabs).forEach((tab) => {
      const title = tabTitle(tab);
      const btn = buttons.find((item) => item.dataset.tab === tab.id);
      if (btn && btn.textContent.trim() !== title) {
        btn.textContent = title;
      }
    });
  }

  function setNavVisibility(navList, tabCount) {
    const hide = tabCount < 2;
    const nav = navList.closest('nav');
    const wrapper = navList.closest(
      '.tabs-with-col_navigation, .tabs-with-table_navigation, .tabs-with-faq_navigation'
    );
    if (nav) nav.classList.toggle('hidden', hide);
    /* FAQ intro copy lives in .tabs-with-faq_navigation; only hide the tab pills. */
    if (wrapper && !wrapper.classList.contains('tabs-with-faq_navigation')) {
      wrapper.classList.toggle('hidden', hide);
    } else if (wrapper) {
      wrapper.classList.remove('hidden');
    }
  }

  function ensureTablist(navList, tabCount) {
    if (tabCount > 0) {
      navList.setAttribute('role', 'tablist');
    } else {
      navList.removeAttribute('role');
    }
  }

  function wireNavEvents(navList, tabs, navItems, sectionId, extra, classSelector) {
    if (navList.dataset.bound === 'true') return;

    navList.addEventListener('click', (e) => {
      const target = e.target.closest(classSelector);
      if (!target) return;
      activateTab(tabs, navItems, sectionId, target.dataset.tab, false, extra);
    });

    navList.addEventListener('keydown', (e) => {
      const current = e.target.closest(classSelector);
      if (!current) return;
      const index = navItems.indexOf(current);
      if (index === -1) return;

      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        activateTab(tabs, navItems, sectionId, current.dataset.tab, false, extra);
        return;
      }

      const lastIndex = navItems.length - 1;
      let nextIndex = index;

      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') nextIndex = index === lastIndex ? 0 : index + 1;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') nextIndex = index === 0 ? lastIndex : index - 1;
      else if (e.key === 'Home') nextIndex = 0;
      else if (e.key === 'End') nextIndex = lastIndex;
      else return;

      e.preventDefault();
      const nextItem = navItems[nextIndex];
      activateTab(tabs, navItems, sectionId, nextItem.dataset.tab, true, extra);
    });

    navList.dataset.bound = 'true';
  }

  function initTabSliders(contextEl) {
    contextEl.querySelectorAll('.tabs-with-videos__slider').forEach((slider) => {
      const nextBtn = slider.querySelector('[data-swiper-next]');
      if (slider.swiper) {
        slider.swiper.update();
        return;
      }
      new Swiper(slider, {
        slidesPerView: 1.2,
        spaceBetween: 13,
        freeMode: true,
        mousewheel: { forceToAxis: true },
        navigation: {
          nextEl: nextBtn,
        },
        breakpoints: { 990: { slidesPerView: 2.2 } },
      });
    });
  }

  function initSection(config, section) {
    const wrapper = section.querySelector(config.wrapperSelector);
    if (!wrapper) return;

    const tabs = Array.from(wrapper.querySelectorAll(config.tabClass));
    const navList = wrapper.querySelector(config.navListSelector);
    if (!tabs.length || !navList) return;

    const panels = namedTabs(tabs);

    setNavVisibility(navList, panels.length);

    if (!navList.querySelector('[role="tab"]')) {
      buildNav(navList, panels, config.navItemClass);
    } else {
      syncNavLabels(navList, panels);
    }
    ensureTablist(navList, navList.querySelectorAll('[role="tab"]').length);
    wrapper.dataset.ready = 'true';

    const navItems = Array.from(navList.querySelectorAll('[role="tab"]'));
    const sectionId = wrapper.id;
    wireNavEvents(navList, tabs, navItems, sectionId, config.initExtra, '[role="tab"]');

    const selectableIds = new Set(navItems.map((item) => item.dataset.tab));
    const selectablePanels = panels.filter((tab) => selectableIds.has(tab.id));
    const stored = activeTabs.get(sectionId);
    const defaultIndex = Math.max(0, (parseInt(wrapper.dataset.defaultIndex, 10) || 1) - 1);
    const initial =
      stored && selectablePanels.some((tab) => tab.id === stored)
        ? stored
        : selectablePanels[defaultIndex]?.id || selectablePanels[0]?.id || null;
    if (initial) activateTab(tabs, navItems, sectionId, initial, false, config.initExtra);
  }

  function initAll() {
    tabConfigs.forEach((config) => {
      const wrappers = document.querySelectorAll(config.wrapperSelector);
      wrappers.forEach((wrapper) => {
        const section = wrapper.closest('[id^="shopify-section"]');
        if (section) initSection(config, section);
      });
    });
  }

  function handleSectionEvent(e) {
    const sectionId = e.detail?.sectionId;
    if (!sectionId) return initAll();
    const section = document.getElementById(`shopify-section-${sectionId}`);
    if (!section) return;
    tabConfigs.forEach((config) => {
      if (section.querySelector(config.wrapperSelector)) initSection(config, section);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initAll();
    if (window.Shopify && window.Shopify.designMode) {
      ['load', 'select', 'reorder'].forEach((name) =>
        document.addEventListener(`shopify:section:${name}`, handleSectionEvent)
      );
      document.addEventListener('shopify:block:select', handleSectionEvent);
    }
  });
})();
